






import ViewModel from '@/views/service/CrewDetail.ts';
export default ViewModel;
